import { API } from "../../constants";
import { ApiResponse } from "../../types";
import { apiSlice } from "../api-slice";
import { GetSeasonsByLeagueQuery, Season } from "./types";

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllSeasonNames: build.query<string[], void>({
      query: () => `${API}/plays/allseasonsbyplays`,
      transformResponse: (response: ApiResponse<string[]>) => response.data,
    }),
    getSeasonsByLeague: build.query<Season[], GetSeasonsByLeagueQuery>({
      query: ({ league }) => `${API}/season?league=${league}`,
    }),
  }),
});

export const {
  useGetAllSeasonNamesQuery,
  useLazyGetAllSeasonNamesQuery,
  useGetSeasonsByLeagueQuery,
  useLazyGetSeasonsByLeagueQuery,
} = extendedApiSlice;
